import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE_URL, ENDPOINTS, getImageUrl, addToCart } from '../../apiConfig';
import './ProductCarousel.css';



const staticSlides = [];

const ProductCarousel = () => {
  const navigate = useNavigate();
  const [slides, setSlides] = useState(staticSlides);
  const [current, setCurrent] = useState(0);
  const [isAddingToCart, setIsAddingToCart] = useState(false);

  useEffect(() => {
    const fetchSliders = async () => {
      try {
        const response = await fetch(`${BASE_URL}${ENDPOINTS.GET_SLIDERS}`);
        const result = await response.json();
        if (result && Array.isArray(result.data) && result.data.length > 0) {
          const activeSliders = result.data.filter(item => item.isActive !== false);
          const mapped = activeSliders.map(item => {
            let sub = item.subtitle || "";
            let tit = item.title || "";
            
            // Extract numbers from either subtitle or title
            let textToSearch = sub + " " + tit;
            let digitsMatch = textToSearch.match(/\d+/);
            
            let t1 = "UP TO";
            let t2 = digitsMatch ? `${digitsMatch[0]}% OFF` : "50% OFF";

            // If the admin put the product name (like 'Room filler') in title or subtitle,
            // we move it to the top small text so it still shows beautifully.
            let topText = "";
            if (tit && !tit.match(/\d+/)) {
               topText = tit;
            } else if (sub && !sub.match(/\d+/)) {
               topText = sub;
            }

            return {
              subtitle: topText,
              title1: t1,
              title2: t2,
              category: item.description || "",
              buttonOneText: item.buttonOneText || "",
              image: getImageUrl(item.image),
              isApiData: true,
              originalData: item
            };
          });
          
          if (mapped.length > 0) {
            setSlides(mapped);
            setCurrent(0);
          }
        }
      } catch (error) {
        console.error("Error fetching sliders:", error);
      }
    };

    fetchSliders();
  }, []);

  useEffect(() => {
    if (slides.length === 0) return;
    const timer = setInterval(() => {
      setCurrent((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 6000);
    return () => clearInterval(timer);
  }, [slides.length]);

  // eslint-disable-next-line no-unused-vars
  const handleNext = (e) => {
    e.stopPropagation();
    setCurrent((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  // eslint-disable-next-line no-unused-vars
  const handlePrev = (e) => {
    e.stopPropagation();
    setCurrent((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const handleSlideClick = async (slide) => {
    const prod = slide.originalData || slide;
    const id = prod?.productId || prod?.product?._id || prod?.product?.id;
    const variantId = prod?.product?.variants?.[0]?._id || null;
    
    if (id) {
      setIsAddingToCart(true);
      try {
        await addToCart(id, variantId, 1);
        setTimeout(() => setIsAddingToCart(false), 1000);
      } catch (err) {
        console.error('Failed to add to cart', err);
        setIsAddingToCart(false);
      }
    } else {
      navigate('/shop');
    }
  };

  return (
    <section className="promo-carousel-wrapper">
      <div className="promo-carousel-container">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`promo-carousel-slide ${index === current ? 'active' : ''}`}
            onClick={() => handleSlideClick(slide)}
          >
            <div className="promo-content">
              <span className="promo-subtitle">{slide.subtitle}</span>
              <h2 className="promo-title">
                <span className="promo-title-1">{slide.title1}</span>
                <span className="promo-title-2">{slide.title2}</span>
              </h2>
              <span className="promo-category">{slide.category}</span>
              {slide.buttonOneText && (
                <button 
                  className="promo-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSlideClick(slide);
                  }}
                >
                  {isAddingToCart ? 'Wait...' : slide.buttonOneText}
                </button>
              )}
            </div>
            
            <div className="promo-image-wrapper">
              <img src={slide.image} alt={slide.category} className="promo-product-image" />
            </div>
          </div>
        ))}

        <div className="promo-dots">
          {slides.map((_, i) => (
            <div
              key={i}
              className={`promo-dot ${i === current ? 'active' : ''}`}
              onClick={(e) => { e.stopPropagation(); setCurrent(i); }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductCarousel;
